var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3871 42.7983C38.6481 46.3991 33.072 48.225 25.8136 48.225C10.9508 48.225 3.4148 40.6889 3.4148 25.8261C3.4148 18.2925 5.37703 12.5798 9.24706 8.84694C12.9841 5.24241 18.5579 3.41473 25.8136 3.41473C33.0706 3.41473 38.6466 5.24248 42.3868 8.8473C46.2608 12.5811 48.225 18.2936 48.225 25.8261C48.225 33.3575 46.2609 39.0677 42.3871 42.7983ZM44.3227 6.83863C48.7633 11.1185 51.0148 17.5068 51.0148 25.8261C51.0148 34.1447 48.7632 40.5311 44.3224 44.8077C40.0456 48.9263 33.8184 51.0147 25.8136 51.0147C17.8097 51.0147 11.5844 48.9263 7.31083 44.8072C2.87448 40.5316 0.625 34.1454 0.625 25.8261C0.625 17.5061 2.87426 11.1179 7.31032 6.83906C11.5851 2.71567 17.8105 0.625 25.8136 0.625C33.8176 0.625 40.0449 2.71559 44.3227 6.83863Z",
    fill: "#CC1F59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8489 34.3521C24.8489 34.9364 25.3237 35.4185 25.9153 35.4185C26.4997 35.4185 26.9817 34.9437 26.9817 34.3521V12.1914C26.9817 11.6071 26.4997 11.125 25.9153 11.125C25.331 11.125 24.8489 11.5998 24.8489 12.1914V34.3521Z",
    fill: "#CC1F59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9226 38.1429C26.843 38.1429 27.5953 38.888 27.5953 39.8156C27.5953 40.7359 26.8503 41.4882 25.9226 41.4882C25.0023 41.4882 24.25 40.7359 24.25 39.8156C24.2573 38.888 25.0023 38.1429 25.9226 38.1429Z",
    fill: "#CC1F59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.007b0943c4fefbf73c6fb48858a0c5fd.svg";
export { ForwardRef as ReactComponent };